import { render } from "./GroupOverview.vue?vue&type=template&id=e4ee0190"
import script from "./GroupOverview.vue?vue&type=script&lang=js"
export * from "./GroupOverview.vue?vue&type=script&lang=js"
script.render = render

export default script